module.exports = "/packs/images/pages/venues/gym_tablet~723441bee82d5a5d18d3f1cf112f0e9c.jpg";